import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ThemeProvider } from 'react-bootstrap'

import { Helmet } from 'react-helmet'

const { instanceOf } = PropTypes
import { Cookies } from 'react-cookie'
import withSafeCookies from './withSafeCookies'

import axios from 'axios'

import YandexMetrika from './block/YandexMetrika';

import './bootstrap.conf.scss';

import Header from './block/Header';
import Footer from './block/Footer';
import TopSearch from './block/TopSearch';
import ProfileSelectorModal from './block/ProfileSelectorModal';
import MobFMenu from './block/MobFMenu';
import MobileMenu from './block/MobileMenu';

import Main from './pages/Main';
import AboutCompany from './pages/AboutCompany';
import Delivery from './pages/Delivery';
import AkciiLegal from './pages/AkciiLegal';
import Feedback from './pages/Feedback';
import Faq from './pages/Faq';
import News from './pages/News';
import Kontakti from './pages/Kontakti';
import Katalog from './pages/Katalog';
import Product from './pages/Product';
import ProductLegal from './pages/ProductLegal';
import Lk from './pages/Lk';
import Favorite from './pages/Favorite';
import Korzina from './pages/Korzina';
import Page from './pages/Page';
import Orders from './pages/Orders';
import Oformlenie from './pages/Oformlenie';
import Oformlen from './pages/Oformlen';
import ULCatalog from './pages/ULCatalog';
import Esert from './pages/Esert';
import LkProduction from './pages/LkProduction';

class App extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    const { cookies } = this.props

    this.state = {
      loading: props?.data.loaded == false || true,
      pages: {},
      page_data: props?.data.page_data || null,
      ajax_data: props?.ajax_data || null,
      search: ``,
      top_search: false,
      search_loading: false,
      search_result: null,
      left_menu: false,
      in_cart_loading: false,
      in_cart: {},
      cart: cookies.get('imidj_cart') || [],
      favorite: cookies.get('imidj_favorite') || [],
      scrollY: 0,
      prevPathname: ``,
      showProfileSelector: false,
      user_profile_type: props?.ajax_data.helmet.host == `ur.stomahelp.ru` ? `legal` : `individual`,
      authorized: false,
      user: props?.ajax_data?.user || {},
      loading_user: true,
      showMobileMenu: false
    }
  }

  handleShowProfileSelect = () => {
    this.setState({
      showProfileSelector: true
    })
  }

  handleCloseProfileSelector = () => {
    this.setState({
      showProfileSelector: false
    })
  }

  changeSearch = (search) => {
    this.setState({
      search: search
    })
  }

  changeTopSearch = ( sst = null ) => {
    if(sst == null) sst = !this.state.top_search
    if(sst) {
      const { search } = this.state
      if( search.length > 3 ) {
        const main = this,
        baseURL = window.location.protocol + "//" + window.location.hostname
        this.setState({
          search_loading: true,
          search_result: null
        }, () => {
          axios.post(`${baseURL}`, {
            'content_type': 'application/json',
            'action': 'find_products',
            'query': search
          }, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Request-Source': 'Node.js'
            }
          }).then( ( response ) => {
            main.setState({
              search_loading: false,
              search_result: response.data
            })
          })
        })
      } else {
        this.setState({
          search_loading: false,
          search_result: null
        })
      }
    }
    this.setState({
      top_search: sst
    })
  }

  changeLeftMenuh = () => {
    this.setState({
      left_menu: !this.state.left_menu
    })
  }

  addTocart = ( elm, fnc = null ) => {
    const { cart } = this.state
    const { cookies } = this.props
    var fined = false
    cart.map(( celm, k ) => {
      if( elm.product == celm.product ) {
        if( elm.count < 1 ) {
          cart.splice(k, 1)
        } else {
          cart[ k ].count = elm.count
        }
        fined = true
      }
    })
    if(!fined && elm?.count > 0) cart.push( elm )

    cookies.set('imidj_cart', cart, { path: '/' })
    this.setState({
      cart: cart
    }, () => {
      if( fnc != null ) fnc()
    })
  }

  clearCart = ( fnc = null ) => {
    const { cookies } = this.props
    cookies.set('imidj_cart', [], { path: '/' })
    this.setState({
      cart: []
    }, () => {
      if( fnc != null ) fnc()
    })
  }

  changeFavorite = ( el ) => {
    const { favorite } = this.state
    const { cookies } = this.props

    if( favorite.includes( el ) ) {
      var index = favorite.indexOf( el )
      if (index !== -1) favorite.splice(index, 1)
    } else {
      favorite.push( el )
    }

    cookies.set('imidj_favorite', favorite, { path: '/' })
    this.setState({
      favorite: favorite
    })
  }

  load_user = () => {
    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_user'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        user: response.data,
        loading_user: false
      }, () => {
        const { user } = main.state

        if(!user.authorized) {
          const { cookies } = main.props,
          user_profile_show = cookies.get('user_profile_show') || false

          if(!user_profile_show) {
            cookies.set('user_profile_show', true, { path: '/' })
            setTimeout( () => {
              main.setState({
                showProfileSelector: true
              })
            }, 3000)
          }
          return
        }

        // Перекидываем пользователя на соответствующую версию сайта
        if( user?.legal && window.location.hostname != `ur.stomahelp.ru` ) {
          window.location.href = `https://ur.stomahelp.ru/`
          return
        }
        if( !user?.legal && window.location.hostname == `ur.stomahelp.ru` ) {
          window.location.href = `https://stomahelp.ru/`
          return
        }

        main.setState({
          authorized: true
        })
      })
    })
  }

  setShowMobileMenu = ( stat ) => {
    this.setState({
      showMobileMenu: stat
    })
  }

  componentDidMount() {
    this.handleScroll = this.handleScroll.bind(this);
    
    window.addEventListener('scroll', this.handleScroll);

    this.handleScroll();

    this.load_user()
  }

  handleScroll() {
    this.setState({
      scrollY: window.scrollY || window.pageYOffset
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  renderContent() {
    const { data, ajax_data } = this.props,
    { favorite, cart, user_profile_type, user, authorized, loading_user } = this.state

    if (!data.loaded) {
      return <p>Данные не загружены</p>
    }

    switch(ajax_data.template) {
      case 1:
        return (
          <Main
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            user_profile_type={user_profile_type}
            authorized={authorized}
          />
        );
      case 2:
        return (
          <AboutCompany
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 3:
        return (
          <Delivery
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 4:
        return (
          <>
            {user_profile_type == `legal` ?
              <AkciiLegal
                data={data}
                ajax_data={ajax_data}
                user_profile_type={user_profile_type}
              />
            :
              <Katalog
                page_data={data?.page_data || {}}
                ajax_data={ajax_data}
                changeFavorite={this.changeFavorite}
                favorite={favorite}
                cart={cart}
                addTocart={this.addTocart}
                catalogmenu={ajax_data?.catalogmenu || []}
                favorite_page={true}
                catalog={data?.catalog || []}
                user_profile_type={user_profile_type}
              />
            }
          </>
        );
      case 5:
        return (
          <Feedback
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 6:
        return (
          <Faq
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 7:
        return (
          <News
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 8:
        return (
          <Kontakti
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 9:
        if(user_profile_type == `legal`) {
          return (
            <ULCatalog
              data={data}
              ajax_data={ajax_data}
              cart={cart}
              addTocart={this.addTocart}
              authorized={authorized}
            />
          )
        }
        return (
          <Katalog
            page_data={data?.page_data || {}}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            catalogmenu={ajax_data?.catalogmenu || []}
            catalog={data?.catalog || []}
            user_profile_type={user_profile_type}
          />
        );
      case 10:
        if(user_profile_type == `legal`) {
          return (
            <ULCatalog
              data={data}
              ajax_data={ajax_data}
              cart={cart}
              addTocart={this.addTocart}
              authorized={authorized}
            />
          )
        }
        return (
          <Katalog
            page_data={data?.page_data || {}}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            catalogmenu={ajax_data?.catalogmenu || []}
            catalog={data?.catalog || []}
            user_profile_type={user_profile_type}
          />
        );
      case 11:
        if(user_profile_type == `legal`) {
          return (
            <ULCatalog
              data={data}
              ajax_data={ajax_data}
              cart={cart}
              addTocart={this.addTocart}
              authorized={authorized}
            />
          )
        }
        return (
          <Product
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            user_profile_type={user_profile_type}
          />
        );
      case 12:
        return (
          <Lk
            data={data}
            ajax_data={ajax_data}
            cart={cart}
            user={user}
            authorized={authorized}
            loading_user={loading_user}
            user_profile_type={user_profile_type}
          />
        );
      case 13:
        return (
          <Favorite
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            authorized={authorized}
            loading_user={loading_user}
            user_profile_type={user_profile_type}
          />
        );
      case 14:
        return (
          <Korzina
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            user_profile_type={user_profile_type}
          />
        );
      case 15:
        return (
          <Page
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 16:
        return (
          <Page
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 17:
        return (
          <Orders
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            clearCart={this.clearCart}
            authorized={authorized}
            loading_user={loading_user}
            user_profile_type={user_profile_type}
          />
        );
      case 18:
        return (
          <Oformlenie
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            clearCart={this.clearCart}
            user={user}
            user_profile_type={user_profile_type}
          />
        );
      case 19:
        return (
          <Oformlen
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 20:
        return (
          <ProductLegal
            data={data}
            ajax_data={ajax_data}
            changeFavorite={this.changeFavorite}
            favorite={favorite}
            cart={cart}
            addTocart={this.addTocart}
            user_profile_type={user_profile_type}
          />
        );
      case 21:
        return (
          <Esert
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 22:
        return (
          <Page
            data={data}
            ajax_data={ajax_data}
            user_profile_type={user_profile_type}
          />
        );
      case 23:
        return (
          <LkProduction
            data={data}
            ajax_data={ajax_data}
            cart={cart}
            addTocart={this.addTocart}
            user={user}
            authorized={authorized}
            loading_user={loading_user}
            user_profile_type={user_profile_type}
          />
        );
      default:
        return <p>Шаблон страницы не распознан</p>;
    }
  }

  // Новый метод для генерации JSON-LD хлебных крошек
  generateBreadcrumbJsonLd() {
    const { data } = this.props;
    const breadcrumbs = data?.breadcrumbs_micro;

    // Проверяем, есть ли данные и это массив
    if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
      return null;
    }

    // Преобразуем формат из data.breadcrumbs в формат Schema.org
    const itemListElement = breadcrumbs.map((item, index) => {
      // Ваш формат: item.item.name и item.item["@id"]
      // Нужно убедиться, что поля существуют
      const name = item?.item?.name;
      const itemUrl = item?.item?.["@id"];

      // Возвращаем только если есть имя
      if (!name) return null;

      return {
        "@type": "ListItem",
        "position": item.position || index + 1, // используем позицию из данных или индекс
        "name": name,
        // Добавляем item только если есть URL
        ...(itemUrl && { "item": itemUrl })
      };
    }).filter(item => item !== null); // Убираем null элементы

    if (itemListElement.length === 0) {
      return null;
    }

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement
    };
  }

  generateProductJsonLd() {
    const { ajax_data } = this.props;
    if (ajax_data?.template !== 11) {
      return null;
    }

    const host = ajax_data?.helmet?.host || 'stomahelp.ru';
    const rawUrl = ajax_data?.url || ajax_data?.url_ng;
    if (!rawUrl) {
      return null;
    }

    const url = rawUrl.startsWith('http')
      ? rawUrl
      : `https://${host}${rawUrl.startsWith('/') ? '' : '/'}${rawUrl}`;

    const images = Array.isArray(ajax_data?.images)
      ? ajax_data.images
          .map((item) => item?.image)
          .filter(Boolean)
          .map((path) =>
            path.startsWith('http')
              ? path
              : `https://${host}${path.startsWith('/') ? '' : '/'}${path}`
          )
      : [];

    const description = ajax_data?.description?.trim() ||
      (typeof ajax_data?.content === 'string'
        ? ajax_data.content.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
        : '');

    const product = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      '@id': url,
      name: ajax_data?.pagetitle || undefined,
      description: description || undefined,
      sku: ajax_data?.article || undefined,
      mpn: ajax_data?.article || undefined,
      url,
      brand: ajax_data?.vendor ? {
        '@type': 'Brand',
        name: ajax_data.vendor
      } : undefined,
      offers: {
        '@type': 'Offer',
        url,
        priceCurrency: 'RUB',
        price: ajax_data?.price != null ? String(ajax_data.price) : undefined,
        itemCondition: 'https://schema.org/NewCondition',
        availability: ajax_data?.options?.stock
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        seller: {
          '@type': 'Organization',
          name: 'StomaHelp'
        }
      }
    };

    if (images.length > 0) {
      product.image = images;
    }

    return product;
  }

  render() {
    const {
      search,
      top_search,
      search_loading,
      search_result,
      cart,
      favorite,
      user_profile_type,
      authorized,
      showMobileMenu
    } = this.state,
    { ajax_data, data } = this.props
    const breadcrumbJsonLd = this.generateBreadcrumbJsonLd(); // генерируем данные
    const productJsonLd = this.generateProductJsonLd();
    // Canonical URL без GET-параметров (url_ng приходит из MODX уже без query-строки)
    const canonicalHost = ajax_data?.helmet?.host || 'stomahelp.ru';
    const canonicalPath = (ajax_data?.url_ng || '/').split('?')[0];
    const canonicalUrl = `https://${canonicalHost}${canonicalPath}`;
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `https://${ajax_data?.helmet.host || 'stomahelp.ru'}#company`,
      "name": "Компания StomaHelp",
      "url": `https://${ajax_data?.helmet.host || 'stomahelp.ru'}`,
      "image": `https://${ajax_data?.helmet.host || 'stomahelp.ru'}/images/logo.png`,
      "telephone": "+7 (831) 231-29-11",
      "email": "sales@stomahelp.ru",
      "priceRange": "₽₽₽",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "ул. Белинского, 32",
        "addressLocality": "г. Нижний Новгород",
        "addressRegion": "Нижегородская область",
        "postalCode": "603000",
        "addressCountry": "RU"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 56.310852,
        "longitude": 43.995773
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.1",
        "reviewCount": "2"
      },
      "sameAs": [
        "https://t.me/+79302834911"
      ]
    }

    return (
      <ThemeProvider
        breakpoints={['xl', 'lg', 'md', 'sm', 'xs']}
        minBreakpoint="xs"
      >
        <Helmet>
          <title>{ajax_data?.helmet.title || 'stomahelp.ru'}</title>

          {/* base должен быть первым элементом после title */}
          <base href={`https://${ajax_data?.helmet.host || 'stomahelp.ru'}/`} />

          <link rel="preconnect" href={`https://${ajax_data?.helmet.host || 'stomahelp.ru'}`} />
          <link rel="dns-prefetch" href={`https://${ajax_data?.helmet.host || 'stomahelp.ru'}`} />

          {/* Канонический URL без GET-параметров */}
          <link rel="canonical" href={canonicalUrl} />

          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="robots" content="all" />

          <meta name="description" content={ajax_data?.helmet.description || 'stomahelp.ru'} />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={ajax_data?.helmet.title || 'stomahelp.ru'} />
          <meta property="og:description" content={ajax_data?.helmet.description || 'stomahelp.ru'} />
          <meta property="og:image" content={`https://${ajax_data?.helmet.host || 'stomahelp.ru'}/files/images/logo.svg`} />
          <meta property="og:url" content={`https://${ajax_data?.helmet.host || 'stomahelp.ru'}`} />

          <link rel="icon" href="/favicon.svg" type="image/svg+xml" />

          <meta name="yandex-verification" content="c99f7d9af8099ad0" />

          <link rel="preconnect" href={`/assets/fonts/Inter/stylesheet.css`} rel="stylesheet" />
          {/* Отложенная загрузка Google Fonts для улучшения PageSpeed 
          <link rel="preconnect" href="https://fonts.googleapis.com" media="print" onload="this.media='all'" />
          <link rel="preconnect" href="https://fonts.gstatic.com" media="print" onload="this.media='all'" />
          <link
            href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
            rel="stylesheet"
            media="print"
            onload="this.media='all'; this.onload=null"
          />
          <noscript>{`<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet" />`}</noscript>
          */}

          {/* Вставляем JSON-LD скрипт */}
          {breadcrumbJsonLd && (
            <script type="application/ld+json">
              {JSON.stringify(breadcrumbJsonLd)}
            </script>
          )}
          {productJsonLd && (
            <script type="application/ld+json">
              {JSON.stringify(productJsonLd)}
            </script>
          )}
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        </Helmet>
        <Header
          options={data?.page_data || {}}
          menu={data?.sitemenu || []}
          catalog={data?.catalog || []}
          changeTopSearch={this.changeTopSearch}
          changeSearch={this.changeSearch}
          favorite={favorite}
          cart={cart}
          authorized={authorized}
          showMobileMenu={() => this.setShowMobileMenu(true)}
          user_profile_type={user_profile_type}
        />
        {this.renderContent()}
        <Footer
          options={data?.page_data || {}}
          menu={data?.sitemenu || []}
          catalog={data?.catalog || []}
          changeTopSearch={this.changeTopSearch}
          changeSearch={this.changeSearch}
          favorite={favorite}
          cart={cart}
          authorized={authorized}
          user_profile_type={user_profile_type}
        />
        <TopSearch
          search={search}
          changeSearch={this.changeSearch}
          changeTopSearch={this.changeTopSearch}
          top_search={top_search}
          loading={search_loading}
          result={search_result}
        />
        {!authorized &&
          <ProfileSelectorModal 
            show={this.state.showProfileSelector} 
            onShow={this.handleShowProfileSelect}
            onClose={this.handleCloseProfileSelector}
            user_profile_type={this.state.user_profile_type}
          />
        }
        <MobFMenu
          options={data?.page_data || {}}
          changeTopSearch={this.changeTopSearch}
          userProfileType={this.state.user_profile_type}
        />
        <MobileMenu 
          show={showMobileMenu} 
          handleClose={() => this.setShowMobileMenu(false)}
          options={data?.page_data || {}}
          menu={data?.sitemenu || []}
          catalog={data?.catalog || []}
          user_profile_type={this.state.user_profile_type}
        />
        <YandexMetrika />
        {ajax_data?.bottom_js && (
          <div dangerouslySetInnerHTML={{ __html: ajax_data.bottom_js }} />
        )}
        {/*
        <h2>Структура данных:</h2>
        <pre>{JSON.stringify({ data: data, ajax_data: ajax_data }, null, 2)}</pre>
        */}
      </ThemeProvider>
    );
  }

}

App.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  get: PropTypes.object
}

export default withSafeCookies(App)
